<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>


export default {
  name: 'Layout',
  data() {
    return {
    };
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

a {
  text-decoration: none;
}

body {
  background-color: #f5f6fa;
  font-family: Microsoft YaHei UI !important;
}

#app {
  width: 100%;
  height: 100vh;
  margin: 0 auto;
}
#app::-webkit-scrollbar {
  display: none;
}
</style>
